export default __webpack_public_path__ + "static/media/GApprove.feed80f2.jpg";